<h3 class="text-center text-light bg-secondary border">{{loadStatus}} ({{filteredLoads.length}})</h3>
<!--
    Pageable grid
    [pageSize]="gridState.take"
    [skip]="gridState.skip"
    [pageable]="{ pageSizes: pageSizes }"

    Full size grid
    [pageable]="false"

    (selectionChange)="rowSelected($event)"
 -->
<kendo-grid #releasedLoadsGrid
            [data]="gridData"
            [sort]="gridState.sort"
            [filter]="gridState.filter"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [pageable]="true"
            [sortable]="true"
            [filterable]="true"
            [resizable]="true"
            [autoSize]="true"
            [selectable]="false"
            [rowClass]="rowCallback"
            class="hideFilterOperators"
            (dataStateChange)="dataStateChange($event)">
    <kendo-grid-column title="Action">
        <ng-template kendoGridCellTemplate let-load>
            <div style="width:115px;">
                <!--<a [routerLink]="" (click)="rowSelected(load)"><i class="fas fa-angle-double-right fa-lg ml-3" [ngClass]="{'text text-primary': load.quoteOrderLineID==selectedLoad.quoteOrderLineID}"></i></a>-->
                <a (click)="sendEmail(load)" title="Email Tender"><i class="text-warning far fa-envelope fa-lg m-1"></i></a>
                <a (click)="viewTracking(load.quoteOrderID)" title="Track"><i class="text-primary far fa-calendar-alt fa-lg m-1"></i></a>
                <a (click)="linkMP(load.quoteOrderLineID)" title="Link MP"><i class="text-secondary fas fa-link fa-lg m-1"></i></a>
                <a (click)="editTender(load)" title="Modify Tender"><i class="text-success fas fa-edit fa-lg m-1"></i></a>
            </div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="macropointOrderID" title="MP Setup">
        <ng-template kendoGridCellTemplate let-load>
            <!--<input type="checkbox" [checked]="load.macropointOrderID>0" disabled />-->
            <i *ngIf="load.macropointOrderID<0||load.macropointOrderID==null" class="far fa-square fa-lg text-secondary"></i>
            <i *ngIf="load.macropointOrderID>0" class="fas fa-check-square fa-lg text-primary"></i>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="orderNumber" title="Order #">
        <ng-template kendoGridCellTemplate let-load>
            <a target="_blank" [routerLink]="['/order-entry', load.quoteOrderID]">{{load.orderNumber}}-{{ load.legNumber}}</a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="loadStatus" title="Load Status"></kendo-grid-column>
    <kendo-grid-column field="orderPriority" title="Priority"></kendo-grid-column>
    <kendo-grid-column field="carrierName" title="Carrier">
        <ng-template kendoGridCellTemplate let-load>
            <a (click)="removeCarrier(load)" title="Remove Carrier"><i class="text-danger fas fa-times-circle fa-lg"></i></a>
            {{load.carrierName}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="awardedLineTypeAbbr" title="Tag Type">
        <ng-template kendoGridCellTemplate let-load>
            <!-- *showRolesIf="'CRM Admin'" -->
            <!--<kendo-dropdownlist [data]="quoteOrderLineTypeTagsList"
                        [textField]="'abbrev'"
                        [valueField]="'abbrev'"
                        [valuePrimitive]="true"
                        [(ngModel)]="dataItem.awardedLineTypeAbbr"
                        (valueChange)="quoteOrderLineTypeTagsChange(dataItem)"></kendo-dropdownlist>-->
            <!-- *hideRolesIf="'CRM Admin'" -->
            <!--<div>{{dataItem.awardedLineTypeAbbr}}</div>-->
            <span *ngIf="!isCSRManager">{{load.awardedLineTypeAbbr}}</span>
            <span *ngIf="isCSRManager">
                <select name="awardedLineTypeAbbr" [(ngModel)]="load.awardedLineTypeAbbr"
                        (change)="quoteOrderLineTypeTagsChange(load.awardedLineTypeAbbr,load,$event)">
                    <option *ngFor="let typeTag of quoteOrderLineTypeTagsList" value="{{typeTag.abbrev}}">{{typeTag.abbrev}}</option>
                </select>
            </span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="trailer" title="Trailer"></kendo-grid-column>
    <kendo-grid-column field="mode" title="Mode"></kendo-grid-column>
    <kendo-grid-column field="rateIndex" title="Rate Index"></kendo-grid-column>
    <kendo-grid-column field="originCity" title="O-City"></kendo-grid-column>
    <kendo-grid-column field="originState" title="O-State"></kendo-grid-column>
    <kendo-grid-column field="destinationCity" title="D-City"></kendo-grid-column>
    <kendo-grid-column field="destinationState" title="D-State"></kendo-grid-column>
    <kendo-grid-column field="isRoundTrip" title="RT">
        <ng-template kendoGridCellTemplate let-load>
            <!--<input type="checkbox" [checked]="load.isRoundTrip" disabled />-->
            <i *ngIf="load.isRoundTrip!=true" class="far fa-square fa-lg text-secondary"></i>
            <i *ngIf="load.isRoundTrip==true" class="fas fa-check-square fa-lg text-primary"></i>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="earliestDate" title="Earliest">
        <ng-template kendoGridCellTemplate let-load>
            {{load.earliestDate == '' ? '' : load.earliestDate | date: 'HH:mm'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="latstDate" title="Latest">
        <ng-template kendoGridCellTemplate let-load>
            {{load.latestDate == '' ? '' : load.latestDate | date: 'HH:mm'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="arrivalStartDate" title="Start">
        <ng-template kendoGridCellTemplate let-load>
            {{load.arrivalStartDate == '' ? '' : load.arrivalStartDate | date: 'M/dd'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="accountManagerName" title="Acct Mgr"></kendo-grid-column>
    <!--<kendo-grid-column field="bookedByCarrierRepName" title="Awarded Rep"></kendo-grid-column>-->
    <kendo-grid-column field="bookedByCarrierRepName" title="Awarded Rep">
        <ng-template kendoGridCellTemplate let-load>
            <!--<a (click)="editCarrierRep(load.quoteOrderLineID,load.awardedCarrierRepID)" *showRolesIf="'Carrier Sales Manager'" title="Change Rep"><i class="text-success fas fa-edit fa-lg"></i></a>-->
            <span *ngIf="!isCSRManager">{{load.bookedByCarrierRepName}}</span>
            <span *ngIf="isCSRManager">
                <select name="awardedCarrierRepID" [(ngModel)]="load.awardedCarrierRepID"
                        (change)="carrierRepChange(load.quoteOrderLineID,load,$event)">
                    <option *ngFor="let rep of carrierReps" value="{{rep.employeeId}}">{{rep.fullName}}</option>
                </select>
            </span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="price" title="Price" format="{0:c}"></kendo-grid-column>
    <kendo-grid-column field="cost" title="Cost" format="{0:c}"></kendo-grid-column>
    <kendo-grid-column field="grossProfit" title="Gross Profit" format="{0:c}"></kendo-grid-column>
    <kendo-grid-column field="margin" title="Margin" format="{0:p}"></kendo-grid-column>
    <kendo-grid-column field="minBidRate" title="Min Rate" format="{0:c}"></kendo-grid-column>
    <kendo-grid-column title="Tags">
        <ng-template kendoGridCellTemplate let-load>
            <span *ngFor="let tag of getTagTypes(load.tagTypes)">
                <tagtype-tag [tag]="tag"></tagtype-tag>
            </span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="billTo" title="Bill To">
        <ng-template kendoGridCellTemplate let-load>
            <a target="_blank" [routerLink]="['/customer-detail', load.billTo]">
                {{load.billTo}} - {{load.billToName}}
            </a>
        </ng-template>
    </kendo-grid-column>
</kendo-grid>

<kendo-dialog *ngIf="(assignedLoad | json) != '{}'" [width]="'50%'" [height]="'75%'" (close)="cancelDialogClick()">
    <kendo-dialog-titlebar>
        <h2>Order #{{assignedLoad.quoteOrderID}}-{{assignedLoad.legNumber}}</h2>
    </kendo-dialog-titlebar>
    <carrier-rep-assigned [quoteOrderLineID]="assignedLoad.quoteOrderLineID"></carrier-rep-assigned>
    <kendo-dialog-actions>
        <button (click)="cancelDialogClick()" class="btn btn-secondary m-2" mat-button>
            Close
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="(removeCarrierOffer | json) != '{}'" [width]="'50%'" [height]="'75%'" (close)="cancelDialogClick()">
    <kendo-dialog-titlebar>
        <h2>Order #{{removeCarrierOffer.quoteOrderLine.quoteOrderID}}-{{removeCarrierOffer.quoteOrderLine.legNumber}}</h2>
    </kendo-dialog-titlebar>
    <div class="row">
        <div class="col-sm-8">
            <label class="font-weight-bold">Select a reason the carrier is being removed from this load.</label>
            <br />
            <select name="carrierDropReasonID" [(ngModel)]="removeCarrierOffer.carrierDropReasonId" class="form-select" required>
                <option *ngFor="let reason of carrierDropReasonList" value="{{reason.carrierDropReasonID}}">{{reason.abbreviation}}: {{reason.description}}</option>
            </select>
        </div>
    </div>
    <div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay':isLoading}" *ngIf="isLoading">
        <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
    </div>
    <kendo-dialog-actions>
        <button (click)="removeCarrierSave()" class="btn btn-primary m-2">
            Remove Carrier
        </button>
        <button (click)="cancelDialogClick()" class="btn btn-secondary m-2">
            Close
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay':isLoading}" *ngIf="isLoading">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
